"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ActivityIndicator = _interopRequireDefault(require("../ActivityIndicator"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _Box = _interopRequireDefault(require("../Box"));
var _StackView = _interopRequireDefault(require("../StackView"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Loading = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    label
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    space: 3,
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StackView.default, {
      direction: "row",
      space: 2,
      tokens: {
        alignItems: 'center'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ActivityIndicator.default, {
        variant: {
          size: 'large'
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        children: label
      })]
    })
  });
});
Loading.displayName = 'Loading';
Loading.propTypes = {
  label: _propTypes.default.string
};
var _default = exports.default = Loading;